import Request from '@/services/request';
import {
  HIERARCHY_CATEGORIES,
  GROUPS_CATEGORIES,
  CHILD_CATEGORIES_BY_PARENT_ID,
  CATEGORY_ATTRIBUTES,
  CHILD_CATEGORIES_BY_GROUP_NAME,
  EXCHANGE_RATES,
  ATTRIBUTE_VALUE_SEARCH,
} from '@/utils/enum/endpoints';
import {
  GET_CATEGORIES_PENDING,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_FAIL,
  GET_BRANDS_PENDING,
  GET_BRANDS_SUCCESS,
  GET_BRANDS_FAIL,
  GET_HIERARCHY_CATEGORIES_PENDING,
  GET_HIERARCHY_CATEGORIES_SUCCESS,
  GET_HIERARCHY_CATEGORIES_FAIL,
  GET_GROUP_CATEGORIES_PENDING,
  GET_GROUP_CATEGORIES_SUCCESS,
  GET_GROUP_CATEGORIES_FAIL,
  GET_CATEGORY_ATTRIBUTES_PENDING,
  GET_CATEGORY_ATTRIBUTES_SUCCESS,
  GET_CATEGORY_ATTRIBUTES_FAIL,
  GET_EXCHANGE_RATES_PENDING,
  GET_EXCHANGE_RATES_SUCCESS,
  GET_EXCHANGE_RATES_FAIL,
  SET_CATEGORY_ID,
} from './mutation-types';

const request = new Request();

const getCategories = async ({ commit }) => {
  commit(GET_CATEGORIES_PENDING);
  try {
    const { data } = await request.get(
      '/category-query/categories/lowest-level',
    );
    commit(GET_CATEGORIES_SUCCESS, data);
    return Promise.resolve(data);
  } catch ({ data }) {
    commit(GET_CATEGORIES_FAIL, data);
    return Promise.reject(data);
  }
};

const getBrands = async ({ commit }) => {
  commit(GET_BRANDS_PENDING);
  try {
    const { data } = await request.get('/seller-product-query/api/v1/brands');
    commit(GET_BRANDS_SUCCESS, data);
    return Promise.resolve(data);
  } catch ({ data }) {
    commit(GET_BRANDS_FAIL, data);
    return Promise.reject(data);
  }
};

const getHierarchyCategories = async ({ commit }) => {
  commit(GET_HIERARCHY_CATEGORIES_PENDING);
  try {
    const { data } = await request.get(HIERARCHY_CATEGORIES);
    commit(GET_HIERARCHY_CATEGORIES_SUCCESS, data);
    return Promise.resolve(data);
  } catch ({ data }) {
    commit(GET_HIERARCHY_CATEGORIES_FAIL, data);
    return Promise.reject(data);
  }
};

const getGroupCategories = async ({ commit }) => {
  commit(GET_GROUP_CATEGORIES_PENDING);
  try {
    const { data } = await request.get(GROUPS_CATEGORIES);
    commit(GET_GROUP_CATEGORIES_SUCCESS, data);
    return Promise.resolve(data);
  } catch ({ data }) {
    commit(GET_GROUP_CATEGORIES_FAIL, data);
    return Promise.reject(data);
  }
};

const getChildByParentId = async (_, parentId) => {
  try {
    const { data } = await request.get(
      CHILD_CATEGORIES_BY_PARENT_ID.replace('{id}', parentId),
    );
    return Promise.resolve(data);
  } catch ({ data }) {
    return Promise.reject(data);
  }
};

const getCategoryAttributes = async ({ commit }, id) => {
  commit(GET_CATEGORY_ATTRIBUTES_PENDING);
  try {
    const { data } = await request.get(CATEGORY_ATTRIBUTES.replace('{id}', id));
    commit(GET_CATEGORY_ATTRIBUTES_SUCCESS, {
      categoryId: id,
      attributes: data,
    });
    return Promise.resolve(data);
  } catch ({ data }) {
    commit(GET_CATEGORY_ATTRIBUTES_FAIL, data);
    return Promise.reject(data);
  }
};

const getChildByGroupName = async (_, groupName) => {
  try {
    const { data } = await request.get(
      CHILD_CATEGORIES_BY_GROUP_NAME.replace('{name}', groupName),
    );
    return Promise.resolve(data);
  } catch ({ data }) {
    return Promise.reject(data);
  }
};

const getExchangeRates = async ({ commit }) => {
  commit(GET_EXCHANGE_RATES_PENDING);
  try {
    const { data } = await request.get(EXCHANGE_RATES, null, {
      baseURL: '/selleroffice/rest',
      headers: {
        Accept: 'application/json',
      },
    });
    commit(GET_EXCHANGE_RATES_SUCCESS, data);
    return Promise.resolve(data);
  } catch ({ data }) {
    commit(GET_EXCHANGE_RATES_FAIL, data);
    return Promise.reject(data);
  }
};

const setCategoryId = ({ commit }, categoryId) => {
  commit(SET_CATEGORY_ID, categoryId);
};

const searchAttributeValue = async (_, { attributeId, categoryId, value }) => {
  try {
    const res = await request.get(
      ATTRIBUTE_VALUE_SEARCH.replace('{categoryId}', categoryId)
        .replace('{attributeId}', attributeId)
        .replace('{value}', value),
    );
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

export default {
  getCategories,
  getBrands,
  getHierarchyCategories,
  getGroupCategories,
  getChildByParentId,
  getCategoryAttributes,
  getChildByGroupName,
  getExchangeRates,
  setCategoryId,
  searchAttributeValue,
};
